var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipelinesSumClicks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 29C13.3478 29 10.8043 27.8938 8.92893 25.9246C7.05357 23.9555 6 21.2848 6 18.5V8.375C6.00252 7.21549 6.44231 6.10423 7.22317 5.28433C8.00402 4.46443 9.06237 4.00264 10.1667 4H21.8333C22.9376 4.00264 23.996 4.46443 24.7768 5.28433C25.5577 6.10423 25.9975 7.21549 26 8.375V18.5C26 21.2848 24.9464 23.9555 23.0711 25.9246C21.1957 27.8938 18.6522 29 16 29ZM10.1667 5C9.31457 5.00132 8.49774 5.35733 7.89521 5.98998C7.29269 6.62262 6.95364 7.4803 6.95238 8.375V18.5C6.95238 21.0196 7.90561 23.4359 9.60237 25.2175C11.2991 26.9991 13.6004 28 16 28C18.3996 28 20.7009 26.9991 22.3976 25.2175C24.0944 23.4359 25.0476 21.0196 25.0476 18.5V8.375C25.0464 7.4803 24.7073 6.62262 24.1048 5.98998C23.5023 5.35733 22.6854 5.00132 21.8333 5H10.1667Z",
    fill: "#2968C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.999 17C15.8594 17 15.7255 16.8946 15.6268 16.7071C15.5281 16.5196 15.4727 16.2652 15.4727 16V8C15.4727 7.73478 15.5281 7.48043 15.6268 7.29289C15.7255 7.10536 15.8594 7 15.999 7C16.1386 7 16.2724 7.10536 16.3711 7.29289C16.4698 7.48043 16.5253 7.73478 16.5253 8V16C16.5253 16.2652 16.4698 16.5196 16.3711 16.7071C16.2724 16.8946 16.1386 17 15.999 17Z",
    fill: "#2968C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelinesSumClicks);
export default __webpack_public_path__ + "static/media/pipelines-sumClicks.30649f826e42f39a1bbb990d01a959b3.svg";
export { ForwardRef as ReactComponent };